import React from "react";
import style from "./JobPostCard.module.css";
import { Link } from "react-router-dom";
import {MapPin} from "../../assets/";

export default function JobPostCard({to, jobTitle, jobType, location}){

    return(
        <Link data-aos="fade-up" data-aos-offset="-10" className={style.JobPostCard_Link} to={to}>
            <div className={style.JobPostCard_container}>
                <p>{jobTitle}</p>
                <div className={style.extra_info}>
                    <p>{jobType}</p>
                    <div className={style.location}>
                        <img src={MapPin} alt="|" />
                        <p>{location?.city}, {location?.state}</p>
                    </div>
                </div>
            </div>
        </Link>
    );
}
